import Button from '@jetbrains/ring-ui/components/button/button'
import classNames from 'classnames'
import * as React from 'react'

import TransformText from '../../../../containers/TransformText'
import {usePermission} from '../../../../hooks/usePermission'
import {useDistanceToNow} from '../../../../hooks/useTimeSelector'
import {useUserDisplayName} from '../../../../hooks/useUserDisplayName'
import {DialogType, Permission, stringifyId} from '../../../../types'
import {noop} from '../../../../utils/empty'
import SvgIcon from '../../../common/SvgIcon/SvgIcon'

import type {Props} from './BuildComment.types'

import styles from './BuildComment.css'

const MIN_LINES = 4

function BuildComment({
  buildId,
  timestamp,
  user,
  text,
  className,
  withIcon,
  buildTypeId,
  projectId,
  compact,
  openDialogAction = noop,
}: Props) {
  const userDisplayName = useUserDisplayName(user, true)
  const isCommentable = usePermission(Permission.COMMENT_BUILD, projectId)
  const handleComment = React.useCallback(
    () => openDialogAction(stringifyId(buildId), DialogType.COMMENT),
    [buildId, openDialogAction],
  )
  const timestampFromNow = useDistanceToNow(timestamp)
  return timestampFromNow != null && userDisplayName != null && text != null ? (
    <div className={classNames(className, styles.wrapper)}>
      {withIcon === true && <SvgIcon icon="comment" className={styles.icon} />}
      <div>
        <span className={styles.userInfo} title={`Commented by ${userDisplayName}`}>
          {`Commented by ${userDisplayName}`}
        </span>
        <span className={styles.timestamp}>{`${timestampFromNow}:`}</span>
        <TransformText
          buildTypeId={buildTypeId}
          text={text}
          lines={compact ? MIN_LINES : null}
          lineHeight={16}
        />
        {isCommentable && (
          <Button className={styles.button} onClick={handleComment} text>
            {'Edit comment...'}
          </Button>
        )}
      </div>
    </div>
  ) : null
}

export default React.memo<Props>(BuildComment)
